import { render, staticRenderFns } from "./AppNavigationItem.vue?vue&type=template&id=1d43b9e2&"
import script from "./AppNavigationItem.vue?vue&type=script&lang=js&"
export * from "./AppNavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports